export default {
  'goldkid-blank:title': 'Балаңыздың деректері:',
  'goldkid-blank:iin': 'Баланың ЖСН',
  'goldkid-blank:no-iin': 'Баланың ЖСН жоқ па?',
  'goldkid-blank:iin-required': 'ЖСН жазыңыз',
  'goldkid-blank:invalid-iin': 'Баланың ЖСН қате жазылған',
  'goldkid-blank:phone': 'Баланың телефон нөмірі',
  'goldkid-blank:phone-required': 'Баланың телефон нөмірін жазыңыз',
  'goldkid-blank:phone-length': 'Телефон нөмірі қате жазылған',
  'goldkid-blank:phone-operator': 'Нөмір ҚР операторларының ешқайсында тіркелмеген',
  'goldkid-blank:phone-number': 'Басқа телефон нөмірін жазу керек',
  'goldkid-blank:phone-note': 'Балаңыздың телефон нөміріне SMS-код жолдап жатырмыз',
  'goldkid-blank:btn': 'Баланың телефон нөмірін растау',
  'goldkid-blank:confirm-doc': 'Батырманы басып, <a class="text-action-link underline">Kaspi Gold ресімдеуге өтініммен </a> танысқаныңызды растайсыз',
  'goldkid-blank:title-name': '{0} телефон нөмірін көрсетіңіз',
  'goldkid-blank:title-description': 'Телефон нөмірі бала Kaspi.kz қосымшасына кіре алуы үшін керек'
}
